<template lang="pug">
  v-container.px-10(fluid)
    v-row
      v-col(cols="12")
        .section__title {{ $t('Common.addEntity', { entity: $tc('User._name', 2) })}}
        .section__subtitle {{ $t('userSelector.userControls') }}

    v-container(v-if="!loading")
      v-row
        v-col(cols="6")
          v-select(
            v-model="selectedRole",
            :items="allRoles",
            :label="$t('userSelector.addRole')",
            item-text="name",
            return-object,
            clearable,
          )
      v-row
        v-col(cols="6")
          app-entity-autocomplete(
            :entity="$findEntity('User')",
            :emit="true",
            v-model="where",
            @input="getUserList",
          )
          v-card(v-if="hasAvailableUsers")
            v-list
              v-list-item(
                v-for="user in userList"
                :key="user.uid"
              )
                v-list-item-content
                  v-list-item-title {{`${user.name} ${user.lastName} (${user.email})`}}
                v-list-item-icon(v-if="selectedRole")
                  v-icon(@click="addUser(user)") mdi-plus
        v-col(cols="6")
          app-entity-autocomplete(
            :entity="$findEntity('User')",
            :emit="true",
            v-model="whereList",
          )
          v-card
            v-list
              v-list-item(
                v-for="user in filteredUserList"
                :key="user.uid"
              )
                v-list-item-content
                  v-list-item-title {{`${user.user.name} ${user.user.lastName} (${user.user.email})`}}
                  v-list-item-title {{`${user.role.name}`}}
                v-list-item-icon
                  v-icon(@click="removeUser(user)") mdi-close
</template>
<script>
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
  name: 'entity-add',
  mixins: [EntityMixin],
  props: ['parent', 'parentInstance'],
  data: () => ({
    errors: {},

    businessScopes: [],
    where: null,
    userList: [],
    allRoles: [],
    // instance.contactParties: [],

    whereList: null,
    timer: null,
    wait: 500,

    selectedRole: null,
    loading: true,
    loadingUser: false,
  }),
  computed: {
    uid () {
      return this.$route.params.item
    },
    hasAvailableUsers() {
      return !_.isEmpty(this.userList);
    },
    filteredUserList() {
      return (this.instance.userRoleBusinessScopes || []).filter(x => x.entityState !== ENV.ENTITY.STATE.DELETED);
    },
  },
  methods: {
    async getUserList () {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
          this.loadingUser = true
          try {
            this.userList = (await axios.get('User', { params: { where: [this.where], withoutGlobalBusinessScope: true }})).data.data;
          } catch (err) {}
          this.loadingUser = false
      }, this.wait)
    },

    addUser(user) {
      // If not found, then add ContactParty. Else, if it is deleted (cannot see it) change to added.
      // Quiero agregar un usuario con un rol, el usuario no esta -> Crear
      // El usuarioo esta pero eliminado -> Crear otro
      // El usuario esta con entity unchanged -> Eliminar el anterior, poner nuevo
      // El usuario esta eliminado y hay otro recien creado -> Remplazar con el mio
      let f = this.instance.userRoleBusinessScopes.findIndex(x => (x.userId === user.id));
      let _urbs;
      if(f === -1) {
        this.instance.userRoleBusinessScopes.push({ user: user, userId: user.id, role: this.selectedRole, roleId: this.selectedRole.id, entityState: ENV.ENTITY.STATE.ADDED, _Entity: "UserRoleBusinessScope" });
      } else {
        // Found at least one urbs that has the user I am adding, find all of them.
        let foundUsers = this.instance.userRoleBusinessScopes.map((x, i) => ({ ...x, i })).filter(x => (x.userId === user.id));
        console.log(this.$cleanString(foundUsers));

        // If there is one of them added, just modified that one
        let fA = foundUsers.find(x => x.entityState === 4)
        if (fA) {
          _urbs = this.instance.userRoleBusinessScopes[fA.i];
          _urbs.roleId = this.selectedRole.id;
          _urbs.role = this.selectedRole;
        } else {
          foundUsers.forEach(({ i }) => {
            _urbs = this.instance.userRoleBusinessScopes[i];
            _urbs.entityState = ENV.ENTITY.STATE.DELETED;
          });
          this.instance.userRoleBusinessScopes.push({ user: user, userId: user.id, role: this.selectedRole, roleId: this.selectedRole.id, entityState: ENV.ENTITY.STATE.ADDED, _Entity: "UserRoleBusinessScope" });
        }
      }

      if(this.instance.entityState === 0 ||this.instance.entityState === 1) this.instance.entityState = 3;
    },
    removeUser(urbs) {
      // If added remove from list, else just convert to delete
      // Remover: If added, then just remove from instance
      if(urbs.entityState === ENV.ENTITY.STATE.ADDED) {
        this.instance.userRoleBusinessScopes = this.instance.userRoleBusinessScopes.filter(x => ((x.userId !== urbs.userId) || (x.roleId !== urbs.roleId)));
      } else {
        const i = _.findIndex(this.instance.userRoleBusinessScopes, x => ((x.userId === urbs.userId) && (x.roleId === urbs.roleId)));
        if(i !== -1) this.instance.userRoleBusinessScopes[i].entityState = ENV.ENTITY.STATE.DELETED;
      }

      if(this.instance.entityState === 0 || this.instance.entityState === 1) this.instance.entityState = 3;
    },
    async load() {
      try {
        this.loading = true;
        if (this.uid) {
          this.allRoles = (await axios.get('Role', { params: { withoutGlobalBusinessScope: true, pageSize: -1 } })).data.data;
          let _instance = (await axios.get(this.parent.name + '/' + this.parentInstance.id,  {
            params: {
              Load: ['userRoleBusinessScopes.User', 'userRoleBusinessScopes.Role']
            }
          })).data
          this.$store.commit('SET_INSTANCE_PATH', { path: 'userRoleBusinessScopes', value: _instance['userRoleBusinessScopes']  });
        }
      } catch (e) {
        console.log(this.$cleanString(e))
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.load();
  },
}
</script>
<style>
.v-text-field--filled input {
  margin-top: 16px !important;
}

.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: inherit !important;
}
</style>
